<template>
    <v-dialog v-model="dialog" persistent width="400">
        <div class="d-flex flex-column justify-center align-center elevation-15 pistas-content">
            <div
                class="pistas-content d-flex flex-column justify-center align-center position-relative pa-10"
            >
                <div class="p-img d-flex flex-column justify-center align-center">
                    <img :src="usedImg" alt="pistas imagen de modal" />
                </div>
                <div class="py-3 d-flex flex-column justify-center align-center">
                    <span class="text-h6 white--text font-weight-bold">{{
                        $t('bookReading.wildcard_used_msg')
                    }}</span>
                </div>
            </div>
        </div>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            usedImg: require('@/assets/img/gamifications/wildcard-used.svg'),
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
    },
}
</script>
<style>
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.pistas-content {
    border-radius: 26px;
    background: linear-gradient(180deg, #6f5fa4 0%, #261c48 100%);
}
.items-unset {
    align-items: unset !important;
}
</style>
